import React, { useEffect, useState } from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  CircularProgress,
  Divider,
  Grid,
  InputAdornment,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import PropTypes from "prop-types";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import { gridSpacing } from "../../../../../store/constants";
import TextField from "../../../../../utils/ui-components/FormsUI/TextField";
// import {ConfigurationService} from '../../../../../assets/_services/configuration-service';
import { openSuccessDialog } from "../../../../../utils/ui-components/pop-ups/SuccessDialog";
import PersonIcon from "@mui/icons-material/Person";
import LockIcon from "@mui/icons-material/Lock";
import IconButton from "@mui/material/IconButton";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import Visibility from "@mui/icons-material/Visibility";
import { UserService } from "../../../../../assets/_services/user-service";
import CheckboxWrapper from "../../../../../utils/ui-components/FormsUI/Checkbox";
import { UserEditValues } from ".";
import RadioGroupWrapper from "../../../../../utils/ui-components/FormsUI/RadioGroup";

const operatorLabels: Record<number, string> = {
  1: "Robi",
  2: "Teletalk",
  3: "Banglalink",
  4: "Grameenphone",
};

CredentialsManagement.propTypes = {
  id: PropTypes.number.isRequired,
  userId: PropTypes.string,
  title: PropTypes.string.isRequired,
  operationCosts: PropTypes.object,
  fetchData: PropTypes.func.isRequired,
};

function CredentialsManagement({ id, operationCosts, title, userId, fetchData }: any) {
  const theme: any = useTheme();
  const matchDownSM = useMediaQuery(theme.breakpoints.down("md"));
  const [expanded, setExpanded] = React.useState<string | false>(id);
  const [isLoading, setIsLoading] = useState(false);

  const [defaultOperator, setDefaultOperator] = useState<
    {
      value: number | string;
      label: string;
    }[]
  >([]);

  useEffect(() => {
    setDefaultOperator(
      Object.entries(operationCosts.smsOperatorConfguraion)
        .filter(([_, value]) => typeof value === "object" && value !== null && "isUse" in value && (value as any).isUse === true)
        .map(([_, value]) => {
          const operator = value as { systemOperatorId: number };
          return {
            value: operator.systemOperatorId,
            label: operatorLabels[operator.systemOperatorId],
          };
        }),
    );
  }, [operationCosts]);

  const [passwordShowOperator, setPasswordShowOperator]: any = React.useState({
    1: { showPassword: false, showConfirmPassword: false },
    2: { showPassword: false, showConfirmPassword: false },
    3: { showPassword: false, showConfirmPassword: false },
    4: { showPassword: false, showConfirmPassword: false },
  });

  const handleClickShowPasswordOperator = (id: number) => {
    setPasswordShowOperator((prevState: any) => ({
      ...prevState,
      [id]: {
        ...prevState[id],
        showPassword: !prevState[id].showPassword,
      },
    }));
  };

  const handleChange = (panelID: string) => (event: React.SyntheticEvent, newExpanded: boolean) => {
    setExpanded(newExpanded ? panelID : false);
  };

  const FORM_VALIDATION = Yup.object().shape({
    smsOperatorConfguraion: Yup.object()
      .shape({
        defaultOperator: Yup.string().required("Select default operator"),
        all: Yup.boolean().notRequired(),
        robi: Yup.object().shape({
          isUse: Yup.boolean().notRequired(),
          userName: Yup.string()
            // .matches(/^[a-zA-Z0-9]*$/, "Contains only letters and numbers")
            .when("isUse", {
              is: (val: any) => val,
              then: (schema: any) => schema.required("Robi username required"),
              otherwise: (schema: any) => schema.notRequired(),
            }),
          tps: Yup.number()
            .when("isUse", {
              is: (val: any) => val,
              then: (schema: any) => schema.required("Robi TPS required"),
              otherwise: (schema: any) => schema.notRequired(),
            })
            .typeError("Allow only numbers")
            .integer("TPS must be an integer")
            .min(1, "TPS must be greater than or equal to 0"),
          password: Yup.string()
            .max(255)
            .when(["isUse", "isUpdate"], {
              is: (isUse: boolean, isUpdate: boolean) => isUse === true && isUpdate === false,
              then: (schema: any) => schema.required("Robi password required"),
              otherwise: (schema: any) => schema.notRequired(),
            }),
        }),
        tl: Yup.object().shape({
          isUse: Yup.boolean().notRequired(),
          userName: Yup.string().when("isUse", {
            is: (val: any) => val,
            then: (schema: any) => schema.required("Teletalk username required"),
            otherwise: (schema: any) => schema.notRequired(),
          }),
          // .matches(/^[a-zA-Z0-9]*$/, "Contains only letters and numbers"),
          tps: Yup.number()
            .when("isUse", {
              is: (val: any) => val,
              then: (schema: any) => schema.required("Teletalk TPS required"),
              otherwise: (schema: any) => schema.notRequired(),
            })
            .typeError("Allow only numbers")
            .integer("TPS must be an integer")
            .min(1, "TPS must be greater than or equal to 0"),
          acode: Yup.string().when("isUse", {
            is: (val: any) => val,
            then: (schema: any) => schema.required("Teletalk acode required"),
            otherwise: (schema: any) => schema.notRequired(),
          }),
          password: Yup.string()
            .max(255)
            .when(["isUse", "isUpdate"], {
              is: (isUse: boolean, isUpdate: boolean) => isUse === true && isUpdate === false,
              then: (schema: any) => schema.required("Teletalk password required"),
              otherwise: (schema: any) => schema.notRequired(),
            }),
        }),
        bl: Yup.object().shape({
          isUse: Yup.boolean().notRequired(),
          userName: Yup.string().when("isUse", {
            is: (val: any) => val,
            then: (schema: any) => schema.required("Banglalink username required"),
            otherwise: (schema: any) => schema.notRequired(),
          }),
          // .matches(/^[a-zA-Z0-9]*$/, "Contains only letters and numbers"),
          tps: Yup.number()
            .when("isUse", {
              is: (val: any) => val,
              then: (schema: any) => schema.required("Banglalink TPS required"),
              otherwise: (schema: any) => schema.notRequired(),
            })
            .typeError("Allow only numbers")
            .integer("TPS must be an integer")
            .min(1, "TPS must be greater than or equal to 0"),
          password: Yup.string()
            .max(255)
            .when(["isUse", "isUpdate"], {
              is: (isUse: boolean, isUpdate: boolean) => isUse === true && isUpdate === false,
              then: (schema: any) => schema.required("Banglalink password required"),
              otherwise: (schema: any) => schema.notRequired(),
            }),
          billmsisdn: Yup.string().when("isUse", {
            is: (val: any) => val,
            then: (schema: any) =>
              schema.matches(/^((880)(\d){10},?)+$/, "Invalid numbers pattern detected").required("Banglalink billmsisdn required"),
            otherwise: (schema: any) => schema.notRequired(),
          }),
        }),
        gp: Yup.object().shape({
          isUse: Yup.boolean().notRequired(),
          userName: Yup.string().when("isUse", {
            is: (val: any) => val,
            then: (schema: any) => schema.required("Grameenphone username required"),
            otherwise: (schema: any) => schema.notRequired(),
          }),
          // .matches(/^[a-zA-Z0-9]*$/, "Contains only letters and numbers"),
          tps: Yup.number()
            .when("isUse", {
              is: (val: any) => val,
              then: (schema: any) => schema.required("Grameenphone TPS required"),
              otherwise: (schema: any) => schema.notRequired(),
            })
            .typeError("Allow only numbers")
            .integer("TPS must be an integer")
            .min(1, "TPS must be greater than or equal to 0"),
          password: Yup.string()
            .max(255)
            .when(["isUse", "isUpdate"], {
              is: (isUse: boolean, isUpdate: boolean) => isUse === true && isUpdate === false,
              then: (schema: any) => schema.required("Grameenphone password required"),
              otherwise: (schema: any) => schema.notRequired(),
            }),
          billmsisdn: Yup.string().when("isUse", {
            is: (val: any) => val,
            then: (schema: any) =>
              schema.matches(/^((0)(\d){10},?)+$/, "Invalid numbers pattern detected").required("Grameenphone billmsisdn required"),
            otherwise: (schema: any) => schema.notRequired(),
          }),
        }),
      })
      .test("valid", "valid", function (this: Yup.TestContext) {
        const { smsOperatorConfguraion } = this.parent;
        const { robi, tl, bl, gp } = smsOperatorConfguraion;
        const isAnyUseTrue = [robi, tl, bl, gp].some((item) => item.isUse === true);
        return isAnyUseTrue;
      }),
  });

  const updateUserSmsConfiogurations = (values: UserEditValues, setSubmitting: any) => {
    setIsLoading(true);
    const formData = {
      userId: values.id,
      isAllOperatorsAllowed: values.smsOperatorConfguraion.all ? 1 : 0,
      defaultOperatorId: values.smsOperatorConfguraion.defaultOperator,
      systemOperatorConfigurations: [
        values.smsOperatorConfguraion.robi.isUse && {
          systemOperatorId: values.smsOperatorConfguraion.robi.systemOperatorId,
          userName: values.smsOperatorConfguraion.robi.userName,
          password: values.smsOperatorConfguraion.robi.password === "" ? null : values.smsOperatorConfguraion.robi.password,
          tps: values.smsOperatorConfguraion.robi.tps,
        },
        values.smsOperatorConfguraion.tl.isUse && {
          systemOperatorId: values.smsOperatorConfguraion.tl.systemOperatorId,
          userName: values.smsOperatorConfguraion.tl.userName,
          password: values.smsOperatorConfguraion.tl.password === "" ? null : values.smsOperatorConfguraion.tl.password,
          acode: values.smsOperatorConfguraion.tl.acode,
          tps: values.smsOperatorConfguraion.tl.tps,
        },
        values.smsOperatorConfguraion.bl.isUse && {
          systemOperatorId: values.smsOperatorConfguraion.bl.systemOperatorId,
          userName: values.smsOperatorConfguraion.bl.userName,
          password: values.smsOperatorConfguraion.bl.password === "" ? null : values.smsOperatorConfguraion.bl.password,
          tps: values.smsOperatorConfguraion.bl.tps,
          billmsisdn: values.smsOperatorConfguraion.bl.billmsisdn,
        },
        values.smsOperatorConfguraion.gp.isUse && {
          systemOperatorId: values.smsOperatorConfguraion.gp.systemOperatorId,
          userName: values.smsOperatorConfguraion.gp.userName,
          password: values.smsOperatorConfguraion.gp.password === "" ? null : values.smsOperatorConfguraion.gp.password,
          tps: values.smsOperatorConfguraion.gp.tps,
          billmsisdn: values.smsOperatorConfguraion.gp.billmsisdn,
        },
      ].filter((item) => typeof item !== "boolean"),
    };
    UserService.updateUserSmsConfigurations(formData).then((response) => {
      if (response.isSuccess) {
        setSubmitting(false);
        setIsLoading(false);
        openSuccessDialog("Success", "SMS operator configuration updated successfully");
        fetchData();
      } else {
        setIsLoading(false);
        setSubmitting(false);
      }
    });
  };

  return (
    <Box>
      <Accordion expanded={expanded === id.toString()} onChange={handleChange(id.toString())}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon sx={{ color: "#ffff" }} />}
          aria-controls="panel1a-content"
          id="panel1a-header"
          sx={{
            backgroundColor: theme.palette.primary.main,
          }}
        >
          <Typography fontWeight={"bold"} variant="h4" color={"#ffff"}>
            SMS Operators Configuration
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Formik
            initialValues={{ ...operationCosts }}
            enableReinitialize={true}
            validationSchema={FORM_VALIDATION}
            onSubmit={(values: UserEditValues, { setSubmitting }) => {
              updateUserSmsConfiogurations(values, setSubmitting);
            }}
          >
            {({ values, dirty, isSubmitting, isValid, errors, setFieldValue, setErrors }) => (
              <Form>
                <Grid container spacing={gridSpacing} justifyContent={"center"}>
                  <Grid item xs={12}>
                    <CheckboxWrapper
                      customHandleChange={(e: any) => {
                        if (e.target.checked) {
                          setFieldValue("smsOperatorConfguraion", {
                            all: true,
                            defaultOperator: "",
                            robi: {
                              ...values.smsOperatorConfguraion.robi,
                              isUse: true,
                            },
                            tl: {
                              ...values.smsOperatorConfguraion.tl,
                              isUse: true,
                            },
                            bl: {
                              ...values.smsOperatorConfguraion.bl,
                              isUse: true,
                            },
                            gp: {
                              ...values.smsOperatorConfguraion.gp,
                              isUse: true,
                            },
                          });
                          setDefaultOperator([
                            { value: 1, label: operatorLabels[1] },
                            { value: 2, label: operatorLabels[2] },
                            { value: 3, label: operatorLabels[3] },
                            { value: 4, label: operatorLabels[4] },
                          ]);
                        } else {
                          setFieldValue("smsOperatorConfguraion", {
                            all: false,
                            defaultOperator: "",
                            robi: {
                              ...values.smsOperatorConfguraion.robi,
                              isUse: false,
                            },
                            tl: {
                              ...values.smsOperatorConfguraion.tl,
                              isUse: false,
                            },
                            bl: {
                              ...values.smsOperatorConfguraion.bl,
                              isUse: false,
                            },
                            gp: {
                              ...values.smsOperatorConfguraion.gp,
                              isUse: false,
                            },
                          });
                          setDefaultOperator([]);
                        }
                      }}
                      legend={"All Operators"}
                      name={"smsOperatorConfguraion.all"}
                      sx={{ pr: 0 }}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <RadioGroupWrapper
                      required
                      name="smsOperatorConfguraion.defaultOperator"
                      label="SMS Default Operator"
                      radioGroup={defaultOperator}
                      disabled={false}
                    />
                  </Grid>

                  <Grid item lg={12} container columnSpacing={1}>
                    <Grid item lg={2} md={2} sm={3} xs={3}>
                      <CheckboxWrapper
                        customHandleChange={(e: any) => {
                          if (
                            e?.target.checked &&
                            values.smsOperatorConfguraion.tl.isUse &&
                            values.smsOperatorConfguraion.bl.isUse &&
                            values.smsOperatorConfguraion.gp.isUse
                          ) {
                            setFieldValue("smsOperatorConfguraion", {
                              ...values.smsOperatorConfguraion,
                              all: true,
                              robi: {
                                ...values.smsOperatorConfguraion.robi,
                                isUse: e?.target.checked,
                              },
                            });
                            setDefaultOperator([...defaultOperator, { value: 1, label: operatorLabels[1] }]);
                          } else {
                            setFieldValue("smsOperatorConfguraion", {
                              ...values.smsOperatorConfguraion,
                              defaultOperator:
                                Number(values.smsOperatorConfguraion.defaultOperator) === 1
                                  ? ""
                                  : Number(values.smsOperatorConfguraion.defaultOperator),
                              all: false,
                              robi: {
                                ...values.smsOperatorConfguraion.robi,
                                isUse: e?.target.checked,
                              },
                            });
                            setDefaultOperator(defaultOperator.filter((item) => item.value !== 1));
                          }

                          if (e?.target.checked) {
                            setDefaultOperator(
                              [...defaultOperator, { value: 1, label: operatorLabels[1] }].sort((a, b) => Number(a.value) - Number(b.value)),
                            );
                          } else {
                            setDefaultOperator(defaultOperator.filter((item) => item.value !== 1).sort((a, b) => Number(a.value) - Number(b.value)));
                          }
                        }}
                        legend={"Robi"}
                        name={"smsOperatorConfguraion.robi.isUse"}
                        sx={{ pr: 0 }}
                      />
                    </Grid>
                    <Grid item lg={10} container spacing={1}>
                      <Grid item lg={2} md={5} sm={8} xs={9}>
                        <TextField
                          required={values.smsOperatorConfguraion.robi.isUse}
                          type={"number"}
                          name="smsOperatorConfguraion.robi.tps"
                          label="TPS"
                        />
                      </Grid>
                      <Grid item lg={4} md={5} sm={8} xs={9}>
                        <TextField
                          required={values.smsOperatorConfguraion.robi.isUse}
                          type={"text"}
                          name="smsOperatorConfguraion.robi.userName"
                          label="Username"
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <PersonIcon />
                              </InputAdornment>
                            ),
                          }}
                        />
                      </Grid>
                      <Grid item lg={4} md={5} sm={8} xs={9}>
                        <TextField
                          required={values.smsOperatorConfguraion.robi.isUse && values.smsOperatorConfguraion.robi.isUpdate === false}
                          type={passwordShowOperator[1]?.showPassword ? "text" : "password"}
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <LockIcon />
                              </InputAdornment>
                            ),
                            endAdornment: (
                              <InputAdornment position="end">
                                <IconButton aria-label="toggle password visibility" onClick={() => handleClickShowPasswordOperator(1)} edge="end">
                                  {passwordShowOperator[1]?.showPassword ? <VisibilityOff /> : <Visibility />}
                                </IconButton>
                              </InputAdornment>
                            ),
                          }}
                          name="smsOperatorConfguraion.robi.password"
                          label="Password"
                          placeholder="Password"
                        />
                      </Grid>
                    </Grid>
                  </Grid>

                  <Grid item lg={12} container columnSpacing={1}>
                    <Grid item lg={2} md={2} sm={3} xs={3}>
                      <CheckboxWrapper
                        customHandleChange={(e: any) => {
                          if (
                            e?.target.checked &&
                            values.smsOperatorConfguraion.robi.isUse &&
                            values.smsOperatorConfguraion.bl.isUse &&
                            values.smsOperatorConfguraion.gp.isUse
                          ) {
                            setFieldValue("smsOperatorConfguraion", {
                              ...values.smsOperatorConfguraion,
                              all: true,
                              tl: {
                                ...values.smsOperatorConfguraion.tl,
                                isUse: e?.target.checked,
                              },
                            });
                          } else {
                            setFieldValue("smsOperatorConfguraion", {
                              ...values.smsOperatorConfguraion,
                              defaultOperator:
                                Number(values.smsOperatorConfguraion.defaultOperator) === 2
                                  ? ""
                                  : Number(values.smsOperatorConfguraion.defaultOperator),
                              all: false,
                              tl: {
                                ...values.smsOperatorConfguraion.tl,
                                isUse: e?.target.checked,
                              },
                            });
                          }
                          if (e?.target.checked) {
                            setDefaultOperator(
                              [...defaultOperator, { value: 2, label: operatorLabels[2] }].sort((a, b) => Number(a.value) - Number(b.value)),
                            );
                          } else {
                            setDefaultOperator(defaultOperator.filter((item) => item.value !== 2).sort((a, b) => Number(a.value) - Number(b.value)));
                          }
                        }}
                        legend={"Teletalk"}
                        name={"smsOperatorConfguraion.tl.isUse"}
                        sx={{ pr: 0 }}
                      />
                    </Grid>
                    <Grid item lg={10} container spacing={1}>
                      <Grid item lg={2} md={5} sm={8} xs={9}>
                        <TextField
                          required={values.smsOperatorConfguraion.tl.isUse}
                          type={"number"}
                          name="smsOperatorConfguraion.tl.tps"
                          label="TPS"
                        />
                      </Grid>
                      <Grid item lg={4} md={5} sm={8} xs={9}>
                        <TextField
                          required={values.smsOperatorConfguraion.tl.isUse}
                          type={"text"}
                          name="smsOperatorConfguraion.tl.userName"
                          label="Username"
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <PersonIcon />
                              </InputAdornment>
                            ),
                          }}
                        />
                      </Grid>
                      <Grid item lg={4} md={5} sm={8} xs={9}>
                        <TextField
                          required={values.smsOperatorConfguraion.tl.isUse && values.smsOperatorConfguraion.tl.isUpdate === false}
                          type={passwordShowOperator[1]?.showPassword ? "text" : "password"}
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <LockIcon />
                              </InputAdornment>
                            ),
                            endAdornment: (
                              <InputAdornment position="end">
                                <IconButton aria-label="toggle password visibility" onClick={() => handleClickShowPasswordOperator(1)} edge="end">
                                  {passwordShowOperator[1]?.showPassword ? <VisibilityOff /> : <Visibility />}
                                </IconButton>
                              </InputAdornment>
                            ),
                          }}
                          name="smsOperatorConfguraion.tl.password"
                          label="Password"
                          placeholder="Password"
                        />
                      </Grid>
                      <Grid item lg={2} md={10} sm={8} xs={9}>
                        <TextField
                          required={values.smsOperatorConfguraion.tl.isUse}
                          type={"text"}
                          name="smsOperatorConfguraion.tl.acode"
                          label="Acode"
                        />
                      </Grid>
                    </Grid>
                  </Grid>

                  <Grid item lg={12} container columnSpacing={1}>
                    <Grid item lg={2} md={2} sm={3} xs={3}>
                      <CheckboxWrapper
                        customHandleChange={(e: any) => {
                          if (
                            e?.target.checked &&
                            values.smsOperatorConfguraion.tl.isUse &&
                            values.smsOperatorConfguraion.robi.isUse &&
                            values.smsOperatorConfguraion.gp.isUse
                          ) {
                            setFieldValue("smsOperatorConfguraion", {
                              ...values.smsOperatorConfguraion,
                              all: true,
                              bl: {
                                ...values.smsOperatorConfguraion.bl,
                                isUse: e?.target.checked,
                              },
                            });
                          } else {
                            setFieldValue("smsOperatorConfguraion", {
                              ...values.smsOperatorConfguraion,
                              defaultOperator:
                                Number(values.smsOperatorConfguraion.defaultOperator) === 3
                                  ? ""
                                  : Number(values.smsOperatorConfguraion.defaultOperator),
                              all: false,
                              bl: {
                                ...values.smsOperatorConfguraion.bl,
                                isUse: e?.target.checked,
                              },
                            });
                          }
                          if (e?.target.checked) {
                            setDefaultOperator(
                              [...defaultOperator, { value: 3, label: operatorLabels[3] }].sort((a, b) => Number(a.value) - Number(b.value)),
                            );
                          } else {
                            setDefaultOperator(defaultOperator.filter((item) => item.value !== 3).sort((a, b) => Number(a.value) - Number(b.value)));
                          }
                        }}
                        legend={"Banglalink"}
                        name={"smsOperatorConfguraion.bl.isUse"}
                        sx={{ pr: 0 }}
                      />
                    </Grid>
                    <Grid item lg={10} container spacing={1}>
                      <Grid item lg={2} md={5} sm={8} xs={9}>
                        <TextField
                          required={values.smsOperatorConfguraion.bl.isUse}
                          type={"number"}
                          name="smsOperatorConfguraion.bl.tps"
                          label="TPS"
                        />
                      </Grid>
                      <Grid item lg={3.5} md={5} sm={8} xs={9}>
                        <TextField
                          required={values.smsOperatorConfguraion.bl.isUse}
                          type={"text"}
                          name="smsOperatorConfguraion.bl.userName"
                          label="Username"
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <PersonIcon />
                              </InputAdornment>
                            ),
                          }}
                        />
                      </Grid>
                      <Grid item lg={3.5} md={5} sm={8} xs={9}>
                        <TextField
                          required={values.smsOperatorConfguraion.bl.isUse && values.smsOperatorConfguraion.bl.isUpdate === false}
                          type={passwordShowOperator[1]?.showPassword ? "text" : "password"}
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <LockIcon />
                              </InputAdornment>
                            ),
                            endAdornment: (
                              <InputAdornment position="end">
                                <IconButton aria-label="toggle password visibility" onClick={() => handleClickShowPasswordOperator(1)} edge="end">
                                  {passwordShowOperator[1]?.showPassword ? <VisibilityOff /> : <Visibility />}
                                </IconButton>
                              </InputAdornment>
                            ),
                          }}
                          name="smsOperatorConfguraion.bl.password"
                          label="Password"
                          placeholder="Password"
                        />
                      </Grid>
                      <Grid item lg={3} md={10} sm={8} xs={9}>
                        <TextField
                          required={values.smsOperatorConfguraion.bl.isUse}
                          type="tel"
                          name="smsOperatorConfguraion.bl.billmsisdn"
                          label="Bill"
                        />
                      </Grid>
                    </Grid>
                  </Grid>

                  <Grid item lg={12} container columnSpacing={1}>
                    <Grid item lg={2} md={2} sm={3} xs={3}>
                      <CheckboxWrapper
                        customHandleChange={(e: any) => {
                          if (
                            e?.target.checked &&
                            values.smsOperatorConfguraion.tl.isUse &&
                            values.smsOperatorConfguraion.bl.isUse &&
                            values.smsOperatorConfguraion.robi.isUse
                          ) {
                            setFieldValue("smsOperatorConfguraion", {
                              ...values.smsOperatorConfguraion,
                              all: true,
                              gp: {
                                ...values.smsOperatorConfguraion.gp,
                                isUse: e?.target.checked,
                              },
                            });
                          } else {
                            setFieldValue("smsOperatorConfguraion", {
                              ...values.smsOperatorConfguraion,
                              defaultOperator:
                                Number(values.smsOperatorConfguraion.defaultOperator) === 4
                                  ? ""
                                  : Number(values.smsOperatorConfguraion.defaultOperator),
                              all: false,
                              gp: {
                                ...values.smsOperatorConfguraion.gp,
                                isUse: e?.target.checked,
                              },
                            });
                          }
                          if (e?.target.checked) {
                            setDefaultOperator(
                              [...defaultOperator, { value: 4, label: operatorLabels[4] }].sort((a, b) => Number(a.value) - Number(b.value)),
                            );
                          } else {
                            setDefaultOperator(defaultOperator.filter((item) => item.value !== 4).sort((a, b) => Number(a.value) - Number(b.value)));
                          }
                        }}
                        legend={"Grameenphone"}
                        name={"smsOperatorConfguraion.gp.isUse"}
                        sx={{ pr: 0 }}
                      />
                    </Grid>
                    <Grid item lg={10} container spacing={1}>
                      <Grid item lg={2} md={5} sm={8} xs={9}>
                        <TextField
                          required={values.smsOperatorConfguraion.gp.isUse}
                          type={"number"}
                          name="smsOperatorConfguraion.gp.tps"
                          label="TPS"
                        />
                      </Grid>
                      <Grid item lg={3.5} md={5} sm={8} xs={9}>
                        <TextField
                          required={values.smsOperatorConfguraion.gp.isUse}
                          type={"text"}
                          name="smsOperatorConfguraion.gp.userName"
                          label="Username"
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <PersonIcon />
                              </InputAdornment>
                            ),
                          }}
                        />
                      </Grid>
                      <Grid item lg={3.5} md={5} sm={8} xs={9}>
                        <TextField
                          required={values.smsOperatorConfguraion.gp.isUse && values.smsOperatorConfguraion.gp.isUpdate === false}
                          type={passwordShowOperator[1]?.showPassword ? "text" : "password"}
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <LockIcon />
                              </InputAdornment>
                            ),
                            endAdornment: (
                              <InputAdornment position="end">
                                <IconButton aria-label="toggle password visibility" onClick={() => handleClickShowPasswordOperator(1)} edge="end">
                                  {passwordShowOperator[1]?.showPassword ? <VisibilityOff /> : <Visibility />}
                                </IconButton>
                              </InputAdornment>
                            ),
                          }}
                          name="smsOperatorConfguraion.gp.password"
                          label="Password"
                          placeholder="Password"
                        />
                      </Grid>
                      <Grid item lg={3} md={10} sm={8} xs={9}>
                        <TextField
                          required={values.smsOperatorConfguraion.gp.isUse}
                          type="tel"
                          name="smsOperatorConfguraion.gp.billmsisdn"
                          label="Bill"
                        />
                      </Grid>
                    </Grid>
                  </Grid>

                  <Grid item xs={12}>
                    {!values.smsOperatorConfguraion.bl.isUse &&
                      !values.smsOperatorConfguraion.gp.isUse &&
                      !values.smsOperatorConfguraion.robi.isUse &&
                      !values.smsOperatorConfguraion.tl.isUse && (
                        <Typography variant="caption" color={"error"}>
                          At least one sms reward operator required
                        </Typography>
                      )}
                  </Grid>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <Stack direction={"row"} justifyContent={"flex-end"}>
                      <Button
                        color="primary"
                        variant="contained"
                        type="submit"
                        size="medium"
                        disabled={!dirty || isSubmitting || !isValid}
                        startIcon={
                          isLoading && (
                            <CircularProgress
                              size={"20px"}
                              sx={{
                                mr: 1,
                                color: "gray",
                              }}
                            />
                          )
                        }
                      >
                        Update
                      </Button>
                    </Stack>
                  </Grid>
                </Grid>
              </Form>
            )}
          </Formik>
        </AccordionDetails>
      </Accordion>
    </Box>
  );
}

export default CredentialsManagement;
